import { render } from "./TablePagingControls.vue?vue&type=template&id=8ec1d7ea&scoped=true&ts=true&lang=pug"
import script from "./TablePagingControls.vue?vue&type=script&lang=ts"
export * from "./TablePagingControls.vue?vue&type=script&lang=ts"

import "./TablePagingControls.vue?vue&type=style&index=0&id=8ec1d7ea&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ec1d7ea"]])

export default __exports__